"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Buttons = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _BuyButton = require("../BuyButton");
var _NotifyMeButton = require("../NotifyMeButton");
var _ReplaceButton = require("../ReplaceButton");
var _SampleOrParentButton = require("../SampleOrParentButton");
var _SubscribeButton = require("../SubscribeButton");
var _constants = require("./constants");
var _styles = require("./styles");
var _types = require("./types");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/jsx-handler-names -- We need to pass onClick handlers like this: replace.onClick */

/**
 * Displays buttons section.
 * TODO: During implementation of redesign of PDP and PID add implementation for onClick actions of each buttons.
 * TODO: Finish documentation of whole component and types.
 */
const Buttons = ({
  buyOrReserve,
  className,
  notifyMe,
  placement,
  primary,
  productCode,
  replace,
  sampleOrParent,
  subscribe
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: className,
    "data-testid": getTestId(_constants.BUTTONS),
    children: [primary === _types.BUY_OR_RESERVE && buyOrReserve?.visible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_BuyButton.BuyButton, {
      buyTitle: buyOrReserve.buyTitle,
      formattedPrice: buyOrReserve.formattedPrice,
      productCode: productCode,
      productName: buyOrReserve.productName,
      reserveTitle: buyOrReserve.reserveTitle,
      disabled: buyOrReserve.disabled,
      isReserve: buyOrReserve.isReserve,
      onlyButton: buyOrReserve.onlyButton,
      placement: placement,
      visible: buyOrReserve.visible,
      onClick: buyOrReserve.onClick
    }) : null, primary === _types.SUBSCRIBE && subscribe?.visible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscribeButton.SubscribeButton, {
      isPrimary: true,
      productCode: productCode,
      title: subscribe.title,
      disabled: subscribe.disabled,
      visible: subscribe.visible,
      onClick: subscribe.onClick
    }) : null, replace?.visible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ReplaceButton.ReplaceButton, {
      isPrimary: !buyOrReserve?.visible && primary !== _types.SUBSCRIBE,
      productCode: productCode,
      title: replace.title,
      disabled: replace.disabled,
      placement: placement,
      replacementCodes: replace.replacementCodes,
      visible: replace.visible,
      onClick: replace.onClick
    }) : null, notifyMe?.visible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_NotifyMeButton.NotifyMeButton, {
      isPrimary: !buyOrReserve?.visible && primary !== _types.SUBSCRIBE && !replace?.visible,
      productCode: productCode,
      title: notifyMe.title,
      disabled: notifyMe.disabled,
      visible: notifyMe.visible,
      onClick: notifyMe.onClick
    }) : null, subscribe?.visible && primary !== _types.SUBSCRIBE ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_SubscribeButton.SubscribeButton, {
      isPrimary: !buyOrReserve?.visible && !replace?.visible && !notifyMe?.visible,
      productCode: productCode,
      title: subscribe.title,
      disabled: subscribe.disabled,
      visible: subscribe.visible,
      onClick: subscribe.onClick
    }) : null, sampleOrParent?.visible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_SampleOrParentButton.SampleOrParentButton, {
      isPrimary: !buyOrReserve?.visible && !subscribe?.visible && !replace?.visible && !notifyMe?.visible,
      fullProductInfoTitle: sampleOrParent.fullProductInfoTitle,
      sampleProductTitle: sampleOrParent.sampleProductTitle,
      disabled: sampleOrParent.disabled,
      parentProducts: sampleOrParent.parentProducts,
      placement: placement,
      sample: sampleOrParent.sample,
      visible: sampleOrParent.visible,
      onClick: sampleOrParent.onClick
    }) : null]
  });
};
exports.Buttons = Buttons;
//# sourceMappingURL=Buttons.js.map